import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/global.css";
import router from "./router";
import store from "./store"; // 引入 store
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.getFullImageUrl = function(relativePath) {
  return `${process.env.VUE_APP_BASE_URL}/prod-api${relativePath}`;
};
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
